import styled from 'styled-components';
import { COLORS } from '../../constants/colors';

export const Shell = styled.div`
  min-height: 100vh;
  background: #f4f6f6;
  padding: 24px 12px 48px;
  display: flex;
  justify-content: center;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 760px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.06);
  overflow: hidden;
`;

export const Header = styled.div`
  background: ${COLORS.gradient.blackPrimary};
  color: #fff;
  padding: 28px 32px 24px;
  border-bottom: 4px solid ${COLORS.$mainTiffany};

  h1 {
    color: #fff;
    font-size: 26px;
    margin: 12px 0 4px;
  }

  p {
    color: rgba(255, 255, 255, 0.8);
    margin: 0;
  }

  @media (max-width: 600px) {
    padding: 22px 20px 20px;

    h1 {
      font-size: 22px;
    }
  }
`;

export const LogoBadge = styled.div`
  display: inline-flex;
  background: #fff;
  border-radius: 10px;
  padding: 6px 10px;

  img {
    height: 36px;
  }
`;

export const Body = styled.div`
  padding: 24px 32px 32px;

  @media (max-width: 600px) {
    padding: 20px 16px 24px;
  }

  .ant-form-item-label > label {
    font-weight: 600;
  }

  .ant-checkbox-group,
  .ant-radio-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`;

export const SecureNote = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-start;
  background: #e6faf8;
  border: 1px solid ${COLORS.$mainTiffany};
  border-radius: 10px;
  padding: 12px 14px;
  margin-bottom: 24px;
  color: #1f3b3b;
  font-size: 14px;
`;

export const SectionTitle = styled.h2`
  font-size: 18px;
  margin: 28px 0 12px;
  padding-bottom: 6px;
  border-bottom: 1px solid #edf0f0;
`;

export const Disclaimer = styled.div`
  background: #fafafa;
  border-left: 3px solid ${COLORS.$mainTiffany};
  border-radius: 6px;
  padding: 12px 14px;
  font-size: 13px;
  color: #444;
  margin: -8px 0 20px;

  ul {
    padding-left: 18px;
    margin: 8px 0;
  }
`;

export const ConsentBox = styled.div`
  max-height: 260px;
  overflow-y: auto;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 14px 16px;
  font-size: 13px;
  line-height: 1.55;
  background: #fcfcfc;
  margin-bottom: 16px;

  ol {
    padding-left: 20px;
  }
`;

export const DependentCard = styled.div`
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  padding: 14px 14px 0;
  margin-bottom: 12px;
  position: relative;
`;

export const SignatureBox = styled.div`
  border: 2px solid ${(p) => (p.$error ? '#ff4d4f' : '#d9d9d9')};
  border-radius: 8px;
  background: #fff;
  position: relative;
  touch-action: none;

  canvas {
    display: block;
  }

  .placeholder {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #bbb;
    pointer-events: none;
  }
`;

export const SubmitRow = styled.div`
  margin-top: 28px;

  .ant-btn {
    height: 48px;
    font-size: 16px;
    font-weight: 600;
  }
`;
